/**
* 模版
**/
<template>
  <div class="tags">
    <el-tag
      :key="tag.func_name"
      type="info"
      v-for="(tag,index) in tags"
      :disable-transitions="false"
      :effect="setTagColor(tag)"
      :closable="tag.func_name=='API类型管理'?false:true"
      @click="changeMenu(tag)"
      @close="handleClose(tag,index)">
      {{tag.func_name}}
    </el-tag>
  </div>
</template>

<script>
  import {mapState, mapMutations} from 'vuex'

  export default {
    computed: {
      ...mapState({
        tags: state => state.tabList,
        historyTags: state => state.historyTabList
      })
    },
    methods: {
      ...mapMutations({
        close: 'closeTab'
      }),
      setTagColor(tag) {
        return this.$route.path === tag.func_url ? 'dark' : 'light'
      },
      changeMenu(tag) {
        //在走一遍vuex中 selectMenu方法，将tag也是内容传递进去
        this.$store.commit('selectMenu', tag)
        this.$router.push({path: tag.func_url})
        localStorage.setItem('path',tag.func_url)
      },
      handleClose(tag, index) {
        let length = this.historyTags.length
        if (this.historyTags.length==1) {
          this.close(tag)
          this.$router.push({path:'/Document/typeDocument'})
          localStorage.setItem('path','/Document/typeDocument')
        } else {
          this.close(tag)
          this.$bus.$emit("clearKeepAlive", tag);
          if (index === length) {
            this.$router.push({path: this.historyTags[index - 2].func_url})
            localStorage.setItem('path',this.historyTags[index - 2].func_url)
          } else {
            this.$router.push({path: this.historyTags[index-1].func_url})
            localStorage.setItem('path',this.historyTags[index-1].func_url)
          }
        }
        // if (tag.menuname!== this.$route.menuname) {
        //   return
        // }
        // 判断vuex中的tabsList下标，如果跟长度相等，跳转后最一个页面
        // if (index === length) {
        //   this.$router.push({path: this.tags[index - 1].url})
        //   localStorage.setItem('path',this.tags[index - 1].url)
        // } else {
        //   this.$router.push({path: this.tags[index].url})
        //   localStorage.setItem('path',this.tags[index].url)
        // }
      }
    }
  }
</script>
<style scoped>
  /deep/.tags .el-tag {
    margin-right: 10px;
    cursor: pointer;
    margin-bottom: 10px;
  }
  /deep/.tags .el-tag--dark.el-tag--info {
    background-color: #ECF5FF;
    border: 1px solid #D9ECFF;
    color: #409EFF;
  }
  /deep/.tags .el-tag--dark.el-tag--info .el-tag__close {
    color: #409EFF;
  }
  /deep/.tags .el-tag--dark.el-tag--info .el-tag__close:hover {
    background: #ECF5FF;
  }
</style>



// WEBPACK FOOTER //
// src/components/tags.vue